import { ArrowUpRight, Award, HeartPulse } from "lucide-react";
import { BOOKING_URL, IMAGES } from "../lib/data";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <div className="lg:col-span-5 relative order-2 lg:order-1">
            <div className="relative">
              <div className="absolute -bottom-6 -right-6 w-2/3 h-2/3 bg-lilac-soft rounded-[2.5rem] -z-10" />
              <img
                src={IMAGES.about}
                alt="A groomer attentively drying a small dog"
                className="w-full h-[520px] object-cover rounded-[2.5rem] shadow-xl"
                data-testid="about-image"
              />
            </div>

            <div
              className="absolute -top-6 -left-6 bg-brown-dark text-cream px-6 py-5 rounded-3xl shadow-lg max-w-[200px]"
              data-testid="about-stat-card"
            >
              <div className="font-serif text-4xl">1:1</div>
              <div
                className="eyebrow mt-1 !text-cream/80"
                style={{ color: "rgba(249, 246, 240, 0.75)" }}
              >
                Only Your Pup
                <br />
                In The Studio
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 order-1 lg:order-2">
            <div className="eyebrow mb-5">— About Barks &amp; Co</div>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-brown-dark leading-[1.05] tracking-tight">
              A boutique grooming
              <br />
              studio, designed for{" "}
              <em className="italic text-lilac-dark">dogs who deserve more</em>.
            </h2>

            <div className="mt-8 space-y-5 text-lg text-text-secondary leading-relaxed max-w-2xl">
              <p>
                Barks &amp; Co is a private boutique grooming studio offering an
                intentionally slower, kinder spa experience. There are no
                kennels, no other dogs barking, and never any rush — just one
                pup at a time, in a quiet, sunny space made just for them.
              </p>
              <p>
                From shy first-timers to seasoned spa-goers, every dog is met
                with patience, gentle hands, and the kind of attention that only
                a one-on-one studio can offer. The result? Beautifully groomed
                pups who actually look forward to coming back.
              </p>
            </div>

            {/* Credentials */}
            <div className="mt-8 flex flex-wrap gap-3" data-testid="about-credentials">
              <div
                data-testid="credential-certified-groomer"
                className="inline-flex items-center gap-2.5 px-4 py-2.5 rounded-full bg-cream-alt border border-[#E6DEC3]"
              >
                <div className="h-7 w-7 rounded-full bg-lilac-soft flex items-center justify-center shrink-0">
                  <Award size={14} className="text-lilac-dark" />
                </div>
                <span className="text-sm text-brown-dark font-medium">
                  Certified &amp; Qualified Groomer
                </span>
              </div>
              <div
                data-testid="credential-pet-first-aid"
                className="inline-flex items-center gap-2.5 px-4 py-2.5 rounded-full bg-cream-alt border border-[#E6DEC3]"
              >
                <div className="h-7 w-7 rounded-full bg-lilac-soft flex items-center justify-center shrink-0">
                  <HeartPulse size={14} className="text-lilac-dark" />
                </div>
                <span className="text-sm text-brown-dark font-medium">
                  Pet First Aid Trained
                </span>
              </div>
            </div>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <a
                href={BOOKING_URL}
                data-testid="about-book-button"
                className="btn-primary"
              >
                Join The Waitlist
                <ArrowUpRight size={18} />
              </a>
              <a
                href="#services"
                data-testid="about-services-link"
                className="text-brown-dark font-medium underline-offset-4 underline decoration-lilac-dark hover:text-lilac-dark transition-colors"
              >
                See what's on offer →
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
